export const acceptedAvatarImageTypes = new Set(['image/png', 'image/jpeg', 'image/jpg']);
